// import countries from '../objects/countryCodes.json';
// const findCountryCode = (countryCode) => {
//   console.log('hhh', countries?.length);
//   let index = countries?.findIndex((x) => x.code == countryCode);
//   if (index != -1) {
//     console.log('gggg', index, countries[index]?.dial_code);
//     return countries[index]?.dial_code;
//   } else {
//     return null;
//   }
// };
// export default findCountryCode;

const findCountryCode = (countryCode, countries) => {
  console.log('hhh', countries?.length, countryCode, countries);
  let index = countries?.findIndex((x) => x.code == countryCode);
  console.log('gggg', index, countryCode, countries);
  if (index != -1) {
    console.log('gggg', index, countries[index]?.dial_code);
    return countries[index]?.dial_code?.replace('+', '');
  } else {
    return null;
  }
};
export default findCountryCode;
